import styled from 'styled-components';
import { useTranslation } from 'next-i18next';
interface BtnProps {
  handleClick: () => void;
}
const RecenterBtn = ({ handleClick }: BtnProps) => {
  const { t } = useTranslation('map');

  return (
    <Container onClick={handleClick}>
      <span>{t('recenter')}</span>
    </Container>
  );
};

const Container = styled.button`
  cursor: pointer;
  background-color: #fff;
  border-radius: 8px;
  padding: 8px;
  color: #000;
  font-family: materialRegular;
  border: none;
  outline: none;
  position: absolute;
  top: 90px;
  inset-inline-start: 16px;
  z-index: 9;
  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    top: 120px;
  }
`;

export default RecenterBtn;
